<template>
  <div>
    <service-quest-list
      :param="{ repair: true }"
      :category="1"
    ></service-quest-list>
  </div>
</template>

<script>
import ServiceQuestList from './list'

export default {
  components: { ServiceQuestList },
}
</script>